export type EpType = TypeEpEnum.ADD | TypeEpEnum.EDIT | TypeEpEnum.DELETE;

export enum TypeEpEnum {
    ADD = 'add',
    EDIT = 'edit',
    DELETE = 'delete'
}